import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckOutForm from "./CheckOutForm";
import { url } from "../../baseUrl";

export default function StripeCardForm({
  transactionId,
  amount,
  account,
  stripeKey,
}) {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    console.log(account);
    fetch(`${url}/stripe/create-payment-intent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        transactionId: transactionId,
        amount: amount,
        account: account,
        currency: "usd",  // ✅ ADD THIS LINE - FIX
      }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [transactionId, amount, account]);  // ✅ Add dependencies

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {clientSecret && (
        <Elements options={options} stripe={loadStripe(`${stripeKey}`)}>
          <CheckOutForm />
        </Elements>
      )}
    </div>
  );
}